module.exports = __webpack_public_path__ + "img/图片12.6370a1f1.png";